import { render, staticRenderFns } from "./UserChoose.vue?vue&type=template&id=0148b4a0&scoped=true"
import script from "./UserChoose.vue?vue&type=script&lang=js"
export * from "./UserChoose.vue?vue&type=script&lang=js"
import style0 from "./UserChoose.vue?vue&type=style&index=0&id=0148b4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0148b4a0",
  null
  
)

export default component.exports